<div class="grid grid-cols-[26px_minmax(0,_1fr)_auto] items-center gap-3 sm:flex">
  <div class="flex">
    <a routerLink="/machine-range/{{ (owningRange$ | async)?.id }}" class="flex items-center justify-center bg-white p-1 border border-grey-300 rounded-sm cursor-pointer sm:hidden">
      <i class="pi pi-chevron-left text-grey-400"></i>
    </a>
  </div>
  <a class="hidden text-muted sm:inline" routerLink="/machine-range/{{ (owningRange$ | async)?.id }}" >{{ (owningRange$ | async)?.name }}</a>
  <div class="hidden text-muted sm:block">/</div>
  @if (owningRange$ | async; as range) {
    <p-select
      class="w-full sm:w-auto sm:max-w-xs"
      [options]="(machinesSelectOptions$| async) ?? []"
      [(ngModel)]="selectedMachineId"
      optionLabel="name"
      optionValue="code"
      placeholder="{{ 'machinePage.selectAMachine' | transloco }}"
      (onChange)="handleChangePage($event, range)"
    />
  }
  <a class="flex items-center gap-2 bg-white px-4 py-2 sm:ml-auto border border-grey-400 rounded-md cursor-pointer" (click)="handleSpecCheckClick()" href="https://portal.speccheck.com/?token=-VNB6mNEC-38" target="_blank">
    <span class="text-sm sm:hidden">{{ 'machinePage.specCheck' | transloco }}</span>
    <span class="hidden text-sm whitespace-nowrap sm:inline">{{ 'machinePage.specCheckApp' | transloco }}</span>
    <i class="pi pi-external-link sm:-order-1"></i>
  </a>
</div>

@if (machine$ | async; as machine) {
  <div class="pt-8 hidden md:block">
    <p-tabs scrollable lazy [value]="machine.placements.at(0)!.id">
      <p-tablist>
        @for (tab of machine.placements; track tab.id) {
          <p-tab [value]="tab.id" (click)="handlePlacementTabClick(tab)">
            {{ tab.name }}
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (tab of machine.placements; track tab.id) {
          <p-tabpanel [value]="tab.id">
            <app-placement-content [allPlacements]="tab.items"></app-placement-content>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>

  <div class="sticky top-0 pt-3 -mx-4 md:hidden">
    <div class="bg-white p-4">
      <div class="flex-grow pb-4">
        <p-select class="w-full sm:w-auto" [options]="(placementCategoryOptions$| async) ?? []" [ngModel]="selectedPlacement$.value" (ngModelChange)="selectedPlacement$.next($event)" (onChange)="handlePlacementSelectChange($event)" optionLabel="name"/>
      </div>
      <div>
        <app-placement-content class="sticky top-0" [allPlacements]="(selectedPlacementItems$ | async) || []"></app-placement-content>
      </div>
    </div>
  </div>
}
